module.exports = __webpack_public_path__ + "media/images/recruitment/pinterest/pinterest-4-c8be2c6970646afd7b8b9be3075b62f4.jpg";